module.exports = __webpack_public_path__ + "static/media/sl-Logo-white.4355aa79.svg";